"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _propsMain = _interopRequireDefault(require("@/components/wl-component-gallery/wl-list/mixins/props-main"));
var _mixins$keys$map$filt, _mixins$keys$map;
var mixins = require.context('./mixins', true, /(.js)$/);
var _default = exports.default = {
  name: 'wl-dialog-select',
  // mixins,
  mixins: [_propsMain.default].concat((0, _toConsumableArray2.default)((_mixins$keys$map$filt = (_mixins$keys$map = mixins.keys().map(function (key) {
    return mixins(key).default;
  })) === null || _mixins$keys$map === void 0 ? void 0 : _mixins$keys$map.filter(function (v) {
    return v;
  })) !== null && _mixins$keys$map$filt !== void 0 ? _mixins$keys$map$filt : [])),
  // mixins,
  data: function data() {
    return {
      visibleDialog: false,
      dialogSelect: [],
      dialogSelectDelect: [],
      dialogSelectValue: '',
      dialogSelectValueJSON: '',
      dialogSelectLabel: '',
      dialogSelectLabelJSON: '',
      selections: [],
      wlDialogOption: {
        okBtn: {
          disabled: true
        }
      }
    };
  },
  computed: {
    computedDialogOptions: function computedDialogOptions() {
      var _Object$keys,
        _this = this;
      var $attrs = {};
      var filterArr = ['dataSource', 'query', 'columns', 'operation', 'rowOperations', 'tableOptions'];
      (_Object$keys = Object.keys(this.$attrs)) === null || _Object$keys === void 0 || _Object$keys.forEach(function (key) {
        return !filterArr.includes(key) && ($attrs[key] = _this.$attrs[key]);
      });
      Object.assign(this.dialogOptions, {
        okBtn: {
          disabled: this.selections.length <= 0
        }
      }, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, $attrs), this.dialogOptions));
      return this.dialogOptions;
    },
    getChooseMode: function getChooseMode() {
      var _this$tableOptions$ch, _this$tableOptions;
      return (_this$tableOptions$ch = (_this$tableOptions = this.tableOptions) === null || _this$tableOptions === void 0 ? void 0 : _this$tableOptions.chooseMode) !== null && _this$tableOptions$ch !== void 0 ? _this$tableOptions$ch : this.chooseMode;
    },
    getSelections: function getSelections() {
      var _this$$refs$wlList$$, _this$$refs$wlList;
      var a = [].concat((0, _toConsumableArray2.default)(this.dialogSelect), (0, _toConsumableArray2.default)(this.selections));
      var b = [];
      var _ref = (_this$$refs$wlList$$ = (_this$$refs$wlList = this.$refs['wl-list']) === null || _this$$refs$wlList === void 0 ? void 0 : _this$$refs$wlList.$refs['wl-table-main']) !== null && _this$$refs$wlList$$ !== void 0 ? _this$$refs$wlList$$ : {},
        getRowKey = _ref.getRowKey;
      a.filter(function (item) {
        return item && getRowKey(item);
      }).forEach(function (item) {
        var v = b.find(function (v2) {
          return getRowKey(v2) === getRowKey(item);
        });
        if (v) Object.assign(v, item);else b.push(item);
      });
      return b;
    },
    wlListOptions: function wlListOptions() {
      var _this2 = this;
      var a = Object.assign({
        chooseMode: this.getChooseMode
      }, this.$attrs);
      var b = Object.keys(_propsMain.default.props);
      var c = {};
      Object.keys(this.$props).filter(function (key) {
        return b.includes(key);
      }).forEach(function (key) {
        return c[key] = _this2.$props[key];
      });
      Object.assign(a, c);
      delete a.value;
      return a;
    }
  },
  /* 数据监听 */
  watch: {
    open: {
      handler: function handler(nv) {
        this.visibleDialog = nv;
      },
      deep: true,
      immediate: true
    },
    visibleDialog: {
      handler: function handler(nv) {
        var _this3 = this;
        var stop = function stop() {
          nv = false;
          _this3.visibleDialog = nv;
          _this3.$emit('update:open', false);
        };
        if (nv) {
          var _this$$refs$wlList2;
          /* 阻止对话框打开的方法 */
          this.$$listenersEmit('open-dialog', stop, this);

          /* 如上边的方法执行完，触发了stop回调函数将 对话框打开状态变更为 false, 那么将组织正在打开的对话框打开 */
          if (!nv) return;
          (_this$$refs$wlList2 = this.$refs['wl-list']) === null || _this$$refs$wlList2 === void 0 || _this$$refs$wlList2.reset();
          this.setSelections();
          this.$emit('update:open', nv);
        } else {
          var _this$$refs$wlList3, _this$$refs$wlList4, _a$;
          // 重置搜索条件
          (_this$$refs$wlList3 = this.$refs['wl-list']) === null || _this$$refs$wlList3 === void 0 || (_this$$refs$wlList3 = _this$$refs$wlList3.getRef('search')) === null || _this$$refs$wlList3 === void 0 || _this$$refs$wlList3.resetSearch();
          this.$nextTick(function () {
            var a = _this3.$refs.input.$el.querySelector('input');
            a.focus();
            a.blur();
          });
          var a = (_this$$refs$wlList4 = this.$refs['wl-list']) === null || _this$$refs$wlList4 === void 0 ? void 0 : _this$$refs$wlList4.getRefs(['table', 'search']);
          if (a) (_a$ = a[0]) === null || _a$ === void 0 || _a$.clearSelection();
          if (this.selectorType === 'onlyBtn') this.dialogSelect.length = 0;
          this.$$listenersEmit('close-dialog', this);
        }
      },
      deep: true,
      immediate: false
    },
    value: {
      handler: function handler(nv) {
        if (nv === this.dialogSelectValue) return;
        if (Array.isArray(nv)) this.dialogSelectValue = nv === null || nv === void 0 ? void 0 : nv.filter(function (v) {
          return v;
        });else this.dialogSelectValue = nv;
        if (this.selectorType !== 'onlyBtn') this.getDialogSelectDatas();
      },
      deep: true,
      immediate: true
    },
    dialogSelectValue: {
      handler: function handler(nv, ov) {
        var _ov$length,
          _nv$length,
          _ov$length2,
          _this4 = this,
          _nv$length2,
          _nv$length3,
          _ov$length3;
        this.dialogSelectValueJSON = JSON.stringify(nv);
        if (((_ov$length = ov === null || ov === void 0 ? void 0 : ov.length) !== null && _ov$length !== void 0 ? _ov$length : 0) !== 0 && ((_nv$length = nv === null || nv === void 0 ? void 0 : nv.length) !== null && _nv$length !== void 0 ? _nv$length : 0) < ((_ov$length2 = ov === null || ov === void 0 ? void 0 : ov.length) !== null && _ov$length2 !== void 0 ? _ov$length2 : 0)) {
          /* 旧数据长度不为零，新数据长度比旧数据短，说明有删除 */
          var a = this.$$anyInArray(nv);
          var b = this.$$anyInArray(ov);
          var c = b.filter(function (s) {
            return !a.includes(s);
          });
          var d = this.dialogSelect;
          this.dialogSelectDelect = [];
          d.forEach(function (item, index) {
            return c.forEach(function (s) {
              var _this4$dialogSelectDe;
              return JSON.stringify(item).includes(s) && (_this4$dialogSelectDe = _this4.dialogSelectDelect).push.apply(_this4$dialogSelectDe, (0, _toConsumableArray2.default)(_this4.dialogSelect.splice(index, 1)));
            });
          });
          this.$$listenersEmit('clear-value', c, this.dialogSelectDelect, this);
        } else if (((_nv$length2 = nv === null || nv === void 0 ? void 0 : nv.length) !== null && _nv$length2 !== void 0 ? _nv$length2 : 0) !== 0 && ((_nv$length3 = nv === null || nv === void 0 ? void 0 : nv.length) !== null && _nv$length3 !== void 0 ? _nv$length3 : 0) > ((_ov$length3 = ov === null || ov === void 0 ? void 0 : ov.length) !== null && _ov$length3 !== void 0 ? _ov$length3 : 0)) {
          /* 新数据长度不为零，新数据长度比旧数据长，说明有新增 */
          this.dialogSelectDelect = [];
        } else if (!nv || nv.length === 0) this.dialogSelect = [];
      },
      deep: true,
      immediate: false
    },
    selections: {
      handler: function handler(nv, ov) {
        /* 取消勾选的 */
        if (ov.length > nv.length) {
          var _this$$refs$wlList5;
          var _this$$refs$wlList$$2 = (_this$$refs$wlList5 = this.$refs['wl-list']) === null || _this$$refs$wlList5 === void 0 ? void 0 : _this$$refs$wlList5.$refs['wl-table-main'],
            getRowKey = _this$$refs$wlList$$2.getRowKey;
          var nvIds = nv.map(function (v) {
            return getRowKey(v);
          });
          var ovIds = ov.map(function (v) {
            return getRowKey(v);
          });
          var delIds = ovIds.filter(function (v) {
            return !nvIds.includes(v);
          });
          if (delIds.length > 0) {
            var _this$dialogSelect;
            var delIndex;
            delIds && ((_this$dialogSelect = this.dialogSelect) === null || _this$dialogSelect === void 0 ? void 0 : _this$dialogSelect.find(function (v, i) {
              return delIds === getRowKey(v) && (delIndex = i);
            }));
            if (delIndex != undefined) {
              this.dialogSelect.splice(delIndex, 1);
            }
          }
        }
        this.dialogOptions.okBtn.disabled = nv.length === 0;
      },
      deep: true
    },
    dialogSelect: {
      handler: function handler() {
        if (this.getChooseMode === 'single' && this.dialogSelect.length > 1) this.dialogSelect.pop();
      },
      deep: true
    },
    columns: {
      handler: function handler() {
        arguments[0].forEach(function (column) {
          return typeof column !== 'boolean' && (column.show = true);
        });
      },
      deep: true,
      immediate: true
    }
  },
  filters: {
    handlerDialogTitle: function handlerDialogTitle(obj) {
      var _ref2, _obj$btnOption$label, _obj$btnOption;
      return (_ref2 = (_obj$btnOption$label = (_obj$btnOption = obj.btnOption) === null || _obj$btnOption === void 0 ? void 0 : _obj$btnOption.label) !== null && _obj$btnOption$label !== void 0 ? _obj$btnOption$label : (0, _typeof2.default)(obj) === 'object' ? obj.title : obj) !== null && _ref2 !== void 0 ? _ref2 : '请选择 - ';
    }
  },
  methods: {
    openDialog: function openDialog() {
      this.visibleDialog = true;
      // this.$$debounce(() => (this.visibleDialog = true), 10)
    },
    /** 点击 确定按钮
     * @description: 点击 对话框
     * @return { void }
     */
    onOk: function onOk() {
      var _this5 = this;
      this.getSelection(function (a /* , b, c */) {
        var fun = function fun() {
          a.forEach(function (v) {
            var d = _this5.dialogSelect.find(function (v2) {
              return _this5.getRowKey(v2) === _this5.getRowKey(v);
            });
            if (d) Object.assign(d, v);else _this5.dialogSelect.push(v);
          });
          var e = _this5.getChooseMode === 'single' ? a : _this5.dialogSelect;

          /* 如果选择模式为单选，那么只要数组最后一位 */
          if (_this5.getChooseMode === 'single' && e.length > 1) e.pop();
          var f = e.map(function (item) {
            return _this5.getRowKey(item);
          });
          var g = e.map(function (item) {
            return _this5.getRowLabel(item);
          });
          _this5.dialogSelectValue = _this5.getChooseMode === 'single' ? g[0] : g;
          _this5.$emit('input', _this5.dialogSelectValue);
          _this5.$emit('change', e);
          _this5.visibleDialog = false;
          _this5.$$listenersEmit('get-selection', e, f, g);
          _this5.$$listenersEmit('selection-confirm', e, f, g);
        };
        if (_this5.$refs['wl-list']) fun();else _this5.$nextTick(fun);
      });
    },
    /** 获取回显数据
     * @description: 获取回显数据，并赋值 this.dialogSelect 中
     * @return { Boolean } 设置成功状态
     */
    getDialogSelectDatas: function getDialogSelectDatas() {
      var _this6 = this;
      try {
        var nv = this.value;
        if (!nv) return true;

        /* 找父组件 wl-form */
        var a = this.$$getComponentParents(this, 'wl-form');

        /* 如果父组件 wl-form 找不到  找 wl-form-control */
        if (!a || this.$$isEmpty(a.form)) a = this.$$getComponentParents(this, 'wl-form-control');

        /* 都找不到就不找了 */
        if (!a || this.$$isEmpty(a.form)) return false;
        var keys = Object.keys(a.form).map(function (key) {
          return a.form[key] === nv ? key : null;
        }).filter(function (key) {
          return key;
        });
        var field;
        if (keys.length === 0) return false;else if (keys.length === 1) field = keys[0];
        if (this.getChooseMode === 'single') {
          var _this$$refs$wlList6;
          var select = this.dialogSelect.find(function (v2) {
            return v2[field] === a.form[field];
          });
          if (!select) this.dialogSelect.push((0, _defineProperty2.default)({}, field, nv));
          return (_this$$refs$wlList6 = this.$refs['wl-list']) === null || _this$$refs$wlList6 === void 0 ? void 0 : _this$$refs$wlList6.setSelections([this.dialogSelect.pop()], field);
        } else {
          var _rowIds, _rowLabels;
          /* 找与这个数据像似的字段 并且包涵 id 字段的，这个值或许是 rowKey 以及 rowLable 的字段，需要作为回显用 */
          var b = Object.keys(a.form).filter(function (key) {
            return (key.includes(field) || key.includes(field.replace(/^(\s)+|(Name|Code|Id)+$/g, ''))) && key !== field;
          });
          if (b.length === 0) return false;
          var c; // 分隔符
          var rowIds;
          var rowLabels;

          /* 获取分隔符 */
          b === null || b === void 0 || b.forEach(function (key) {
            var _d, _d2;
            // if ((/^(\s)+|(Id)+$/g).test(key)) rowIds
            var d = a.form[key];
            if (!d) return;
            if (typeof d === 'number') d = String(d);
            var e = (_d = d) === null || _d === void 0 ? void 0 : _d.indexOf(nv[0]);
            var f = (_d2 = d) === null || _d2 === void 0 ? void 0 : _d2.indexOf(nv[1]);
            if (e > -1 && c !== d.substring(e + nv[0].length, f)) {
              c = d.substring(e + nv[0].length, f);
            }
          }) /* 找相应字段 */;
          [field].concat((0, _toConsumableArray2.default)(b)).forEach(function (key) {
            var d = a.form[key];
            if (_this6.$$isEmpty(d)) return;
            /* 处理 id */
            if (/^(\s)+|(Id)+$/g.test(key)) {
              if (Array.isArray(d)) rowIds = d;else if (typeof d === 'string') rowIds = d === null || d === void 0 ? void 0 : d.split(c);
            } /* 处理 label */else if (/^(\s)+|(Name)+$/g.test(key)) {
              if (Array.isArray(d)) rowLabels = d;else if (typeof d === 'string') rowLabels = d === null || d === void 0 ? void 0 : d.split(c);
            }
          });
          if (this.$$isNoEmpty(rowIds) && this.$$isNoEmpty(rowLabels) && ((_rowIds = rowIds) === null || _rowIds === void 0 ? void 0 : _rowIds.length) === ((_rowLabels = rowLabels) === null || _rowLabels === void 0 ? void 0 : _rowLabels.length)) {
            var _this$$refs$wlList7, _this$$refs$wlList8;
            var com = (_this$$refs$wlList7 = this.$refs['wl-list']) === null || _this$$refs$wlList7 === void 0 ? void 0 : _this$$refs$wlList7.$refs['wl-table-main'];
            if (!com) return false;
            var _com$table = com === null || com === void 0 ? void 0 : com.table,
              rowKey = _com$table.rowKey,
              rowLabel = _com$table.rowLabel;
            rowKey && rowIds.forEach(function (v, i) {
              var obj = {};
              rowKey && (obj[rowKey] = v);
              rowLabel && (obj[rowLabel] = rowLabels[i]);
              var select = _this6.dialogSelect.find(function (v2) {
                return v2[rowKey] === v || com.getRowKey(v2) === v;
              });
              if (!select && _this6.$$isNoEmpty(obj)) _this6.dialogSelect.push(obj);
            });
            return (_this$$refs$wlList8 = this.$refs['wl-list']) === null || _this$$refs$wlList8 === void 0 ? void 0 : _this$$refs$wlList8.setSelections(this.dialogSelect);
          }
        }
      } catch (e) {
        // console.log(e)
      }
      return false;
    },
    /** 设置选中数据
     * @return { void }
     */
    setSelections: function setSelections() {
      var _this$$refs$wlList9;
      var status = this.getDialogSelectDatas();
      !status && this.$$isNoEmpty(this.dialogSelect) && ((_this$$refs$wlList9 = this.$refs['wl-list']) === null || _this$$refs$wlList9 === void 0 ? void 0 : _this$$refs$wlList9.setSelections(this.dialogSelect));
    },
    /**
     * @description: 获取 表格选中条目
     * @param { Function } fun 按钮对象
     * @param { Array } fun.a 选中条目
     * @param { Array } fun.b 选中条目中被作为行key的字段
     * @param { Array } fun.c 选中条目中被作为行label的字段
     * @return { Array } 表格选中条目
     */
    getSelection: function getSelection(fun) {
      var a = [],
        b = [],
        c = [];
      this.$refs['wl-list'].getSelection(function () {
        var _arguments = Array.prototype.slice.call(arguments);
        a = _arguments[0];
        b = _arguments[1];
        c = _arguments[2];
      });
      typeof fun === 'function' && fun(a, b, c);
      return a;
    },
    /** 双击 行
     * @description: 双击 行
     * @param { Object } row 行数据
     * @param { Object } column 列数据
     * @param { Object } event 点击事件
     * @return { void }
     */
    rowDblclick: function rowDblclick() {
      if (this.getChooseMode === 'single') {
        this.$$debounce(this.onOk, 10);
      }
    } /* row , column, event */,
    /**
     * @description: selection-change 表格选中行发生改变触发事件
     * @param { Array } selection 选中条目
     * @return { void }
     */
    selectionChange: function selectionChange(selection) {
      this.selections = selection;
    },
    /** 清除标签
     * @description: 多选模式下移除tag时触发
     * @param { String } tag 移除的tag值
     * @param { Object } item 行数据
     * @return { void }
     */
    selectRemoveTag: function selectRemoveTag(tag, item) {
      var _this7 = this;
      if (typeof this.getRowKey === 'function') {
        var _this$dialogSelect2, _this$$refs$wlList0;
        var delId;
        item && ((_this$dialogSelect2 = this.dialogSelect) === null || _this$dialogSelect2 === void 0 ? void 0 : _this$dialogSelect2.find(function (v, i) {
          return _this7.getRowKey(item) === _this7.getRowKey(v) && (delId = i);
        }));
        this.dialogSelect.splice(delId, 1);
        (_this$$refs$wlList0 = this.$refs['wl-list']) === null || _this$$refs$wlList0 === void 0 || _this$$refs$wlList0.setSelections(this.dialogSelect);
      }
      this.$$listenersEmit('remove-tag', tag);
    },
    /** 请求结束后回调函数
     * @return { void }
     */
    requestFinally: function requestFinally() {
      this.setSelections();
      this.$$listenersEmit('request-finally');
    },
    /** 请求结束后回调函数
     * @return { void }
     */
    change: function change() {
      this.setSelections();
      this.$$listenersEmit('change');
    },
    /** 获取行唯一键
     * @param { Object } item 行数据
     * @return { String } 行唯一键
     */
    getRowKey: function getRowKey(item) {
      var _this$$refs$wlList1;
      return (_this$$refs$wlList1 = this.$refs['wl-list']) === null || _this$$refs$wlList1 === void 0 || (_this$$refs$wlList1 = _this$$refs$wlList1.$refs['wl-table-main']) === null || _this$$refs$wlList1 === void 0 ? void 0 : _this$$refs$wlList1.getRowKey(item);
    },
    /** 获取行标签
     * @param { Object } item 行数据
     * @return { String } 行标签
     */
    getRowLabel: function getRowLabel(item) {
      var _this$$refs$wlList10;
      var a = (_this$$refs$wlList10 = this.$refs['wl-list']) === null || _this$$refs$wlList10 === void 0 || (_this$$refs$wlList10 = _this$$refs$wlList10.$refs['wl-table-main']) === null || _this$$refs$wlList10 === void 0 ? void 0 : _this$$refs$wlList10.getRowLabel(item);
      var b = this.$$isNoEmpty(a, 'string');
      return b || this.getRowKey(item);
    }
  },
  created: function created() {}
};